import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ArrowRight } from "@phosphor-icons/react";
import useReveal from "../../../../lib/useReveal";
import "./gallery.scss";

import g1 from "../../../../images/1.jpg";
import g2 from "../../../../images/2.jpg";
import g3 from "../../../../images/3.jpg";
import g4 from "../../../../images/4.jpg";
import g5 from "../../../../images/5.jpg";
import g6 from "../../../../images/6.jpg";
import g7 from "../../../../images/7.jpg";
import g8 from "../../../../images/8.jpg";
import g9 from "../../../../images/9.jpg";
import g10 from "../../../../images/10.jpg";
import g11 from "../../../../images/11.jpg";
import g12 from "../../../../images/12.jpg";
import feed from "../../../../lib/instagram.json";

gsap.registerPlugin(ScrollTrigger);

const INSTAGRAM = "https://www.instagram.com/delaina.design/";
const BUNDLED = [g1, g2, g3, g4, g5, g6, g7, g8, g9, g10, g11, g12];

// The bundled stills stand in until scripts/fetch-instagram.js has run, so the
// section still renders on a checkout with no Instagram token configured.
const TILES = feed.length
  ? feed.map((post) => ({ ...post, src: `${process.env.PUBLIC_URL}${post.src}` }))
  : BUNDLED.map((src, i) => ({
      id: src,
      src,
      alt: `Product visualisation study ${i + 1} by Delaina Fernandes`,
    }));

const Gallery = () => {
  const sectionRef = useRef(null);
  const revealRef = useReveal({ threshold: 0.1 });

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const mm = gsap.matchMedia();

    // Columns drift at different rates as the section passes, so the grid
    // gains depth instead of arriving as one flat slab.
    mm.add(
      "(min-width: 768px) and (prefers-reduced-motion: no-preference)",
      () => {
        const ctx = gsap.context(() => {
          gsap.utils.toArray(".gallery__item").forEach((el, i) => {
            const lane = i % 4;
            gsap.to(el, {
              yPercent: lane % 2 === 0 ? -9 : -20,
              ease: "none",
              scrollTrigger: {
                trigger: section,
                start: "top bottom",
                end: "bottom top",
                scrub: 0.5,
              },
            });
          });
        }, section);
        return () => ctx.revert();
      }
    );

    return () => mm.revert();
  }, []);

  return (
    <section
      className="gallery"
      id="gallery"
      ref={sectionRef}
      aria-labelledby="gallery-heading"
    >
      <div className="gallery__inner" ref={revealRef}>
        <h2 className="gallery__heading" id="gallery-heading" data-reveal>
          Gallery
        </h2>

        <ul className="gallery__grid">
          {TILES.map((tile) => (
            <li className="gallery__item" key={tile.id}>
              <img
                src={tile.src}
                alt={tile.alt}
                loading="lazy"
                decoding="async"
              />
            </li>
          ))}
        </ul>

        <a
          className="gallery__cta"
          href={INSTAGRAM}
          target="_blank"
          rel="noreferrer"
          data-reveal
        >
          Visit the gallery
          <ArrowRight size={18} weight="bold" />
        </a>
      </div>
    </section>
  );
};

export default Gallery;
